@if (getSupportingDocumentContent) {
  <simple-card class="SupportingDocumentationReview__SimpleCard">
    <div
      title
      class="SupportingDocumentationReview__Title"
      data-test-id="SupportingDocumentationReviewTitle"
    >
      <h6 class="t-bold">{{ documentationConfig.title }}</h6>
      @if (isEditable) {
        <icon
          name="edit"
          [config]="{ type: 'link' }"
          data-test-id="SupportingDocumentationReviewIcon"
          (click)="editIconClicked()"
        ></icon>
      }
    </div>
    @for (
      documentInfo of supportingDocumentationUploadedFiles;
      track documentInfo
    ) {
      <div class="SupportingDocumentationReview__Document">
        <icon
          name="pdf"
          [config]="{ type: 'link' }"
          class="SupportingDocumentationReview__DocumentIcon"
        >
        </icon>
        <a
          class="t-data t-link"
          (click)="downloadDocument(documentInfo.id, documentInfo.file_name)"
          target="_blank"
          >{{ documentInfo.file_name }}</a
        >
      </div>
    }
    @for (
      documentInfo of summaryPageDocumentUploadedFiles;
      track documentInfo
    ) {
      <div class="SupportingDocumentationReview__Document">
        <icon
          name="pdf"
          [config]="{ type: 'link' }"
          class="SupportingDocumentationReview__DocumentIcon"
        >
        </icon>
        <a
          class="t-data t-link"
          (click)="downloadDocument(documentInfo.documentId, documentInfo.name)"
          target="_blank"
          >{{ documentInfo.name }}</a
        >
      </div>
    }
  </simple-card>
}
